<div class="py-5 px-7 bg-white border rounded">
  <slot />
</div>
